import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type RegisterUbsUserAccessTokenMutationVariables = Types.Exact<{
  input: Types.RegisterUbsUserAccessTokenInput;
}>;


export type RegisterUbsUserAccessTokenMutation = { __typename?: 'Mutation', registerUbsUserAccessToken?: { __typename?: 'RegisterUbsUserAccessTokenPayload', id?: string | null } | null };


export const RegisterUbsUserAccessToken = /*#__PURE__*/ gql`
    mutation RegisterUbsUserAccessToken($input: RegisterUbsUserAccessTokenInput!) {
  registerUbsUserAccessToken(input: $input) {
    id
  }
}
    ` as unknown as DocumentNode<RegisterUbsUserAccessTokenMutation, RegisterUbsUserAccessTokenMutationVariables>;

          

          export const useRegisterUbsUserAccessTokenMutation = (options?:MutationHookOptions<RegisterUbsUserAccessTokenMutation, RegisterUbsUserAccessTokenMutationVariables>) => useMutation(RegisterUbsUserAccessToken, options);
          

          export type RegisterUbsUserAccessTokenMutationOptions = MutationHookOptions<RegisterUbsUserAccessTokenMutation, RegisterUbsUserAccessTokenMutationVariables>;

          

          export type RegisterUbsUserAccessTokenMutationResult = ReturnType<typeof useRegisterUbsUserAccessTokenMutation>[1];

          
